import React, {Component} from "react";
import {connect} from "react-redux";
import {oneclickChangeAmount, oneclickToggle} from "../redux/actions/oneclick";
import Loading from "./Loading";

class Oneclick extends Component {
	onclickToggle() {
		this.props.onOneclickToggle();
	}

	changeAmount(e) {
		this.props.onOneclickChangeAmount(e.target.value);
	}

	selectAll(e) {
		e.target.select();
	}

	render() {
		const {couponStorage, oneclick, auth} = this.props;

		if ( !auth.isAuth ) {
			return <div></div>;
		}

		return (
			// Ставка в один клик
			<div className="oneclick">
				<div className="oneclick__header">
					<span>Ставка в один клик</span>
					<div className="oneclick__header-toggle" onClick={this.onclickToggle.bind(this)}>
						<i className={`fas fa-chevron-down ${this.props.oneclick.isOneClick && 'rotate'}`}></i>
					</div>
				</div>

				<div className="oneclick__content">
					{oneclick.processing &&
					<div className="coupon__content-processing animated fadeIn">
						<Loading/>
					</div>}

					<div className="oneclick__messages">{couponStorage.hasOwnProperty('messages') && couponStorage.messages}</div>

					{this.props.oneclick.isOneClick &&
					<div>
						<input type="text" name="oneclick_cmount"
						       onClick={this.selectAll.bind(this)}
						       value={this.props.oneclick.amount}
						       onChange={this.changeAmount.bind(this)}/>
					</div>
					}
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		auth          : state.auth,
		couponStorage : state.coupon,
		oneclick      : state.oneclick,
	}),
	dispatch => ({
		onOneclickToggle       : () => {
			dispatch(oneclickToggle());
		},
		onOneclickChangeAmount : (amount) => {
			dispatch(oneclickChangeAmount(amount));
		},
	})
)(Oneclick);


// WEBPACK FOOTER //
// ./src/app/components/Oneclick.js